import { Component } from '@angular/core';
import { RootMixin, WithMenubarMixin } from '@asp/mixins';

@Component({
  selector: 'app-no-role-layout',
  templateUrl: './no-role-layout.component.html',
  styleUrls: ['./no-role-layout.component.scss'],
})
export class NoRoleLayoutComponent extends WithMenubarMixin(RootMixin) {
  constructor() {
    super();
  }
}
